import clsx from 'clsx'
import { KTIcon } from '../../../helpers'
// import { ThemeModeSwitcher} from '../../../partials'
import { useLayout } from '../../core'
import { HeaderUserMenu } from './header-menus/HeaderUserMenu'
import { useEffect, useState } from 'react'
import { jwtDecode } from 'jwt-decode'
import { UserType } from '../../../../app/models/UserType'


const toolbarUserAvatarHeightClass = 'symbol-24px symbol-md-24px'
const btnIconClass = 'fs-2'

const Navbar = () => {
  const { config } = useLayout()
  const token = localStorage.getItem("token");

  const [nameSurname, setNameSurname] = useState('');

  useEffect(() => {
    if (token === null) {
      return;
    }
    const userToken = jwtDecode(token) as UserType;
    setNameSurname(userToken.name ?? "-");
  }, [token]);

  return (
    <div className='app-navbar flex-shrink-0'>
      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div id='kt_activities_toggle' className={btnClass}>
          <KTIcon iconName='chart-simple' className={btnIconClass} />
        </div>
      </div> */}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <div className={clsx('position-relative', btnClass)} id='kt_drawer_chat_toggle'>
          <KTIcon iconName='message-text-2' className={btnIconClass} />
          <span className='bullet bullet-dot bg-success h-6px w-6px position-absolute translate-middle top-0 start-50 animation-blink' />
        </div>
      </div> */}

      {/* <div className={clsx('app-navbar-item', itemClass)}>
        <ThemeModeSwitcher toggleBtnClass={clsx('btn-active-light-primary btn-custom')} />
      </div> */}

      <div className='d-flex align-items-stretch flex-shrink-0' style={{ fontSize: 14 }}>
        <div
          className={('d-flex align-items-center')}
          id='kt_header_user_menu_toggle'
        >
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          >
            <i className="bi bi-envelope-paper px-2" style={{ fontSize: 24, color: '#24344C' }}></i>
          </div>
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          >
            <i className="bi bi-gear px-2" style={{ fontSize: 24, color: '#24344C' }}></i>
          </div>
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
          >
            <i className="bi bi-bell px-2" style={{ fontSize: 24, color: '#24344C' }}></i>
          </div>
        </div>
        {/* begin::User */}
        <div
          className={clsx('d-flex align-items-center')}
          id='kt_header_user_menu_toggle'
        >
          {/* begin::Toggle */}
          <div
            className={clsx('cursor-pointer symbol', toolbarUserAvatarHeightClass)}
            data-kt-menu-trigger='click'
            data-kt-menu-attach='parent'
            data-kt-menu-placement='bottom-end'
            data-kt-menu-flip='bottom'
          >
            <i className="bi bi-person px-2" style={{ fontSize: 30, color: '#24344C' }}></i>
          </div>
          {nameSurname}
          <HeaderUserMenu />
          {/* end::Toggle */}
        </div>
        {/* end::User */}
      </div>
      {config.app?.header?.default?.menu?.display && (
        <div className='app-navbar-item d-lg-none ms-2 me-n3' title='Show header menu'>
          <div
            className='btn btn-icon btn-active-color-primary w-35px h-35px'
            id='kt_app_header_menu_toggle'
          >
            <KTIcon iconName='text-align-left' className={btnIconClass} />
          </div>
        </div>
      )}

    </div>
  )
}

export { Navbar }
